

















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

@Component({
	computed: {
		...mapGetters("users", ["userInfo"]),
		...mapGetters("project", ["project", "contributers", "loadingProject"])
	},
	methods: {
		...mapActions("project", ["getSingleProject", "sendInvitationEmail"])
	}
})
export default class ProjectDetail extends Vue {
	@Prop({ type: String, required: true })
	id!: string;
	userInfo!: any;
	project!: any;
	getSingleProject!: Function;
	sendInvitationEmail!: Function;
	loadingProject!: boolean;
	loadingproj!: any;
	contributers!: any;
	email = "";
	itemsPerPage = 5;

	dialogm1 = "";
	dialog = false;

	searchadmin = "";
	searchcontrib = "";
	selectedadmin = [];
	selectedcontrib = [];
	headers = [
		{
			text: "UserName",
			align: "start",
			filterable: true,
			value: "name"
		},
		{ text: "UserType", value: "name" },
		{ text: "Email", value: "email" }
	];

	created() {
		this.getSingleProject(this.id);
	}

	openChat(id: string) {
		this.$router.push({ name: "Chat", params: { id } });
		this.getSingleProject(this.id);
	}

	sendEmail() {
		this.$vs.notification({
			icon: "<i class='bx bx-mail-send'></i>",
			color: "success",
			position: "top-right",
			title: "Email sent",
			text: `Email sent successfully for ${this.email}`
		});

		this.dialog = false;
		this.sendInvitationEmail({
			projectname: this.project.title,
			destination: this.email,
			sender: this.userInfo.email
		});
		this.email = "";
	}
}
